import { breakpoints } from '../utils';

export default () => ({
  menuMobileIsActive: false,
  menuDesktopActive: 0,
  showSearch: false,
  init() {
    window.addEventListener('keyup', (e) => {
      if (this.menuDesktopActive > 0) {
        const currentMenuDesktop = Array.from(document.querySelectorAll('.header-menu-desktop'))[
          this.menuDesktopActive - 1
        ];
        const currentLi = currentMenuDesktop.closest('li.main-nav-item');
        const currentButton = currentLi.querySelector('button.main-nav-btn');

        if (e.key === 'Escape') {
          currentButton.focus();
          this.menuDesktopActive = 0;
        }

        if (e.key === 'Tab') {
          if (e.target.closest('li.main-nav-item') !== currentLi) {
            this.menuDesktopActive = 0;
          }
        }
      }
      if (this.menuMobileIsActive) {
        if (e.key === 'Escape') {
          this.menuMobileIsActive = false;
        }
      }
    });

    window.addEventListener('click', (e) => {
      if (this.menuDesktopActive > 0) {
        if (!e.target.closest('.header-menu-desktop') &&
          !e.target.classList.contains('header-menu-desktop') &&
          !e.target.closest('.main-nav-btn') &&
          !e.target.classList.contains('main-nav-btn')) {
          this.menuDesktopActive = 0;
        }
      }
    });

    const mediaQueryIsDesktop = window.matchMedia(`(min-width: ${breakpoints.md}px)`);

    mediaQueryIsDesktop.addEventListener('change', (e) => {
      if (e.matches) {
        this.menuMobileIsActive = false;
      }
    });

    this.$watch("menuMobileIsActive", () => {
      if (this.menuMobileIsActive) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  handleToggleMenuMobile() {
    this.menuMobileIsActive = !this.menuMobileIsActive;
  },
  handleClickMenuDesktopToggle(id) {
    if (this.menuDesktopActive === id) {
      this.menuDesktopActive = 0;
      return;
    }

    this.menuDesktopActive = id;
  }
});
